export default __webpack_public_path__ + "static/media/12_Pachelbel.96cad7fd.mp3";